<template>
    <div>
        <div style="display: flex;margin-top: 20px;" @click="goOff()">
          <van-icon name="arrow-left" size="1.5em" />
          <span style="font-weight: 600;color: #000;">返回</span>
        </div>
        <div>
            <div>
            <p style="margin-top: 20px;margin-left: 20px;">购买记录</p>
            <div class="xuexitou">
              <div class="biaoxiang">
                <div class="xiaotanyi" style="line-height: 50px;"><span>商品名称</span></div>
                <div class="xiaotaner" style="line-height: 50px;"><span>商品售价</span></div>
                <div class="xiaotansan" style="line-height: 50px;"><span>下单时间</span></div>
                <div class="xiaotansi" style="line-height: 50px;"><span>订单号</span></div>
              </div>
            </div>
            <div class="biaoxiang" v-for="(item, index) in xuexi" :key="index">
                <div class="xiaotanyi"><span style="font-size: 12px;">{{item.goods_name}}</span></div>
                <div class="xiaotaner"><span style="font-size: 12px;">{{item.price}}</span></div>
                <div class="xiaotansan"><span style="font-size: 12px;">{{item.pay_time}}</span></div>
                <div class="xiaotansi"><span style="font-size: 12px;">{{item.order_no}}</span></div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import qs from "qs";
	export default {
		data() {
			return {
        xuexi: []
			}
		},
		created(){
			this.infogeren()
      console.log('hhhhhhhhk==========', this.$route.query.fans_id)
		},
		methods: {
      infogeren() {
        var that = this;
				this.axios.post('http://liveapi2.tenghuiwangxiao.com/api/ds/user/order_data', qs.stringify({ fansId: 1076933 }))
				.then(function(data){
			        if(data.data.code == "200") {
                that.xuexi = data.data.data
			        }
			    })
			},
      goOff(){
          this.$router.go(-1);
      },
		}
	}
</script>
<style scoped>
   .xuexitou {
    margin-top: 20px;
    height: 50px;
    width: 100%;
    background: lightblue;
  }
  .biaoxiang {
    width: 348px;
    height: 55px;
    /* line-height: 50px; */
    display: flex;
    margin: 0 auto;
    margin-top: 10px;
  }
  .xiaotanyi {
    width: 87px;
    height: 55px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 55px;
  }
  .xiaotaner {
    width: 87px;
    height: 55px;
    text-align: center;
    line-height: 55px;
    /* overflow: hidden; */
  }
  .xiaotansan {
    width: 87px;
    height: 55px;
    text-align: center;
    line-height: 26px;
    /* overflow: hidden; */
  }
  .xiaotansi {
    width: 87px;
    height: 55px;
    text-align: center;
    word-wrap:break-word
    /* overflow: hidden; */
  }
</style>


// WEBPACK FOOTER //
// MyPurchased.vue?23bfe802